import {InlineDatumReactComponentProps} from '@stripe-internal/inline-data';
import {view, Icon, Tooltip} from '@sail/ui';
import {checkCircleFilled} from '@sail/icons/react/Icon';
import {defineMessage, FormattedMessage} from 'react-intl';

const messages = {
  getYouStarted: defineMessage({
    id: 'mse_inline_data.checkout_studio_greeting.get_you_started',
    description: 'Get you started message',
    defaultMessage: 'We set a few things up to get you started.',
  }),
  continueCustomize: defineMessage({
    id: 'mse_inline_data.checkout_studio_greeting.continue_customize',
    description: 'Continue customizing message',
    defaultMessage: "Continue customizing or implement now if you're ready.",
  }),
  pullInBrandingStyles: defineMessage({
    id: 'mse_inline_data.checkout_studio_greeting.pull_in_branding_styles',
    description: 'Pull branding styles',
    defaultMessage: 'Pulled in <Tooltip>branding styles</Tooltip>',
  }),
  addedPaymentMethodLogic: defineMessage({
    id: 'mse_inline_data.checkout_studio_greeting.added_payment_method_logic',
    description: 'Added payment method logic',
    defaultMessage: 'Added <Tooltip>payment method logic</Tooltip>',
  }),
  tailoredToPricingModel: defineMessage({
    id: 'mse_inline_data.checkout_studio_greeting.tailored_to_pricing_model',
    description: 'Tailored to your pricing model',
    defaultMessage: 'Tailored to <Tooltip>your pricing model</Tooltip>',
  }),
  enabledLocalizedPricing: defineMessage({
    id: 'mse_inline_data.checkout_studio_greeting.enabled_localized_pricing',
    description: 'Enabled localized pricing',
    defaultMessage: 'Enabled <Tooltip>localized pricing</Tooltip>',
  }),
  enabledLocalizedPricingTooltop: defineMessage({
    id: 'mse_inline_data.checkout_studio_greeting.enabled_localized_pricing_tooltip',
    description: 'Enabled localized pricing tooltip',
    defaultMessage:
      'Adaptive Pricing boosts international revenue by up to 17% by letting customers pay in their own currency',
  }),
};

export const CheckoutStudioGreeting = (
  _props: InlineDatumReactComponentProps,
) => {
  return (
    <>
      <view.div css={{stack: 'y', gap: 'medium'}}>
        <FormattedMessage {...messages.getYouStarted} />
        <view.div css={{stack: 'y', gap: 'small'}}>
          <view.div css={{stack: 'x', gap: 'small'}}>
            <Icon icon={checkCircleFilled} size="xsmall" />
            <FormattedMessage
              {...messages.pullInBrandingStyles}
              values={{
                Tooltip: (label: React.ReactNode) => (
                  <Tooltip
                    placement="top"
                    trigger={
                      <view.span css={{color: 'action.primary'}}>
                        {label}
                      </view.span>
                    }
                  >
                    <FormattedMessage
                      {...messages.enabledLocalizedPricingTooltop}
                    />
                  </Tooltip>
                ),
              }}
            />
          </view.div>
          <view.div css={{stack: 'x', gap: 'small'}}>
            <Icon icon={checkCircleFilled} size="xsmall" />
            <FormattedMessage
              {...messages.addedPaymentMethodLogic}
              values={{
                Tooltip: (label: React.ReactNode) => (
                  <Tooltip
                    placement="top"
                    trigger={
                      <view.span css={{color: 'action.primary'}}>
                        {label}
                      </view.span>
                    }
                  >
                    <FormattedMessage
                      {...messages.enabledLocalizedPricingTooltop}
                    />
                  </Tooltip>
                ),
              }}
            />
          </view.div>
          <view.div css={{stack: 'x', gap: 'small'}}>
            <Icon icon={checkCircleFilled} size="xsmall" />
            <FormattedMessage
              {...messages.tailoredToPricingModel}
              values={{
                Tooltip: (label: React.ReactNode) => (
                  <Tooltip
                    placement="top"
                    trigger={
                      <view.span css={{color: 'action.primary'}}>
                        {label}
                      </view.span>
                    }
                  >
                    <FormattedMessage
                      {...messages.enabledLocalizedPricingTooltop}
                    />
                  </Tooltip>
                ),
              }}
            />
          </view.div>
          <view.div css={{stack: 'x', gap: 'small'}}>
            <Icon icon={checkCircleFilled} size="xsmall" />
            <FormattedMessage
              {...messages.enabledLocalizedPricing}
              values={{
                Tooltip: (label: React.ReactNode) => (
                  <Tooltip
                    placement="top"
                    trigger={
                      <view.span css={{color: 'action.primary'}}>
                        {label}
                      </view.span>
                    }
                  >
                    <FormattedMessage
                      {...messages.enabledLocalizedPricingTooltop}
                    />
                  </Tooltip>
                ),
              }}
            />
          </view.div>
        </view.div>
        <FormattedMessage {...messages.continueCustomize} />
      </view.div>
    </>
  );
};
